// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__3qWLu","errorLogs":"EditorFooter_errorLogs__EOdru"};